import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiUsers } from 'react-icons/fi';
import backofficeService from '../../../services/backofficeService';

const PartnersList = () => {
  const [partners, setPartners] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadPartners();
  }, []);

  const loadPartners = async () => {
    try {
      const data = await backofficeService.getPartners();
      setPartners(data);
    } catch (error) {
      console.error('Erro ao carregar parceiros:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Tem a certeza que deseja eliminar este parceiro?')) return;
    
    try {
      await backofficeService.deletePartner(id);
      setPartners(partners.filter(p => p.id !== id));
    } catch (error) {
      alert('Erro ao eliminar parceiro: ' + error.message);
    }
  };

  if (isLoading) {
    return (
      <div className="backoffice-page">
        <div className="loading-state">
          <div className="loading-spinner"></div>
          <p>A carregar parceiros...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="backoffice-page partners-list">
      <div className="page-header">
        <h1>Parceiros</h1>
        <Link to="/backoffice/partners/new" className="btn-primary">
          + Novo Parceiro
        </Link>
      </div>

      {partners.length > 0 ? (
        <table className="data-table">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Categoria</th>
              <th>Website</th>
              <th>Ordem</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {partners.map((partner) => (
              <tr key={partner.id}>
                <td>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    {partner.logo && (
                      <img 
                        src={partner.logo} 
                        alt={partner.name} 
                        style={{ width: '32px', height: '32px', borderRadius: '6px', objectFit: 'contain', background: 'rgba(255,255,255,0.1)' }}
                      />
                    )}
                    {partner.name}
                  </div>
                </td>
                <td>{partner.category || '-'}</td>
                <td>
                  {partner.website ? (
                    <a href={partner.website} target="_blank" rel="noopener noreferrer" style={{ color: '#a29bfe' }}>
                      Visitar
                    </a>
                  ) : '-'}
                </td>
                <td>{partner.order || 0}</td>
                <td>
                  <div className="table-actions">
                    <button 
                      onClick={() => navigate(`/backoffice/partners/${partner.id}`)}
                      className="action-btn edit"
                    >
                      Editar
                    </button>
                    <button 
                      onClick={() => handleDelete(partner.id)}
                      className="action-btn delete"
                    >
                      Eliminar
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="empty-state">
          <FiUsers className="empty-state-icon" />
          <h3>Sem parceiros registados</h3>
          <p>Clique em "Novo Parceiro" para adicionar o primeiro.</p>
        </div>
      )}
    </div>
  );
};

export default PartnersList;
